
		<info-modal [title]="title" (onOk)="ok()">
			<loading [isLoad]="!stats || (stats && stats.length == 0)"></loading>

			<table class="table">
				<thead>
					<th>{{ 'adminstat.support.accessor.time' | translate }}</th>
					<th>{{ 'adminstat.common.Site' | translate }}</th>
					<th>{{ 'adminstat.support.accessor.isSet' | translate }}</th>
					<th>{{ 'adminstat.support.accessor.at the moment' | translate }}</th>
					<th>&nbsp;</th>
				</thead>

				<tbody>
					<tr *ngFor="let stat of stats">
						<td>
							 {{ stat.time || '' }}
						</td>

						<td>
							<a target="_blank" rel="noreferrer" [href]="'http://' + stat.url">{{ stat.domainUrl }}</a>
						</td>

						<td>
							<ng-container *ngIf="mark == 'edit'">
								{{ stat.category }} - {{ stat.subCategory }}
							</ng-container>

							<ng-container *ngIf="mark != 'edit'">
								{{ 'adminstat.support.accessor.site is defered' | translate }}
							</ng-container>
						</td>

						<td>
							<ng-container *ngIf="stat.realCategory == null && stat.realSubCategory == null">
								{{ 'adminstat.support.accessor.not setted' | translate }}
							</ng-container>
							
							<ng-container *ngIf="stat.realCategory != null || stat.realSubCategory != null">
								{{ stat.realCategory }} - {{ stat.realSubCategory }}
							</ng-container>
						</td>

						<td>
							<button type="button" class="btn btn-outline-dark btn-sm">
								<i class="fa fa-pencil-alt" aria-hidden="true" style="cursor:pointer;" (click)="editSiteCategory(stat.siteId)"></i>
							</button>
						</td>
					</tr>
				</tbody>
			</table>
		</info-modal>
	